import { toast } from "react-toastify";
import {
  fetchUpdatePriceBookStart,
  fetchUpdatePriceBookSuccess,
  fetchUpdatePriceBookFailure,
} from "./reducer";

import { UPDATE_PRICEBOOK } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const updatePriceBook =
  (jsonObj, priceBookId, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchUpdatePriceBookStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        UPDATE_PRICEBOOK(priceBookId),
        "PUT",
        jsonObj,
      );

      if (response?.error) {
        dispatch(fetchUpdatePriceBookFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchUpdatePriceBookSuccess(response));
        dispatch(setSuccessMessage(true));
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchUpdatePriceBookFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
